import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { PLANS } from "../../data/content";
import { CtaButton, Eyebrow, Reveal } from "./Primitives";

const Plan = ({ p, i }) => {
  const dark = p.popular;
  return (
    <Reveal delay={i * 0.1} className="h-full">
      <motion.div
        whileHover={{ y: -8 }}
        transition={{ type: "spring", stiffness: 260, damping: 24 }}
        data-testid={`pricing-card-${p.id}`}
        className={`relative flex h-full flex-col rounded-[30px] p-7 sm:p-9 ${dark ? "bg-ink text-paper shadow-[0_40px_80px_-40px_rgba(29,63,217,0.7)]" : "border border-ink/10 bg-white text-ink"}`}
      >
        <div className="flex items-center justify-between">
          <span className={`font-mono text-[12px] uppercase tracking-[0.16em] ${dark ? "text-paper/60" : "text-ink/55"}`}>{p.seg}</span>
          {p.popular && <span className="rounded-full bg-cobalt-600 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white">Most popular</span>}
        </div>
        <h3 className="mt-6 font-display text-3xl font-bold tracking-[-0.02em]">{p.name}</h3>
        <p className={`mt-2 text-[15px] ${dark ? "text-paper/70" : "text-ink/65"}`}>{p.note}</p>
        <div className={`mt-8 border-y py-6 ${dark ? "border-paper/15" : "border-ink/10"}`}>
          <span className="font-display text-5xl font-bold tracking-[-0.04em]" data-testid={`pricing-price-${p.id}`}>{p.price}</span>
          <span className={`ml-2 text-[14px] ${dark ? "text-paper/70" : "text-ink/60"}`}>{p.per}</span>
        </div>
        <p className={`mt-6 text-[13px] font-semibold uppercase tracking-[0.14em] ${dark ? "text-cobalt-200" : "text-cobalt-700"}`}>{p.lead}</p>
        <ul className="mt-4 space-y-3">
          {p.items.map((it) => (
            <li key={it} className="flex items-start gap-3 text-[15px]">
              <Check className={`mt-0.5 h-4 w-4 shrink-0 ${dark ? "text-cobalt-200" : "text-cobalt-700"}`} />
              <span className={dark ? "text-paper/85" : "text-ink/80"}>{it}</span>
            </li>
          ))}
        </ul>
        <div className="mt-auto pt-10">
          <CtaButton testId={`pricing-cta-${p.id}`} variant={dark ? "light" : "solid"} className="w-full justify-between">{p.cta}</CtaButton>
        </div>
      </motion.div>
    </Reveal>
  );
};

export const Pricing = () => (
  <section id="pricing" data-testid="pricing-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
    <div className="mb-16 grid gap-8 lg:grid-cols-12 lg:items-end">
      <Reveal className="lg:col-span-7">
        <Eyebrow>Transparent service segments</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-ink sm:text-5xl lg:text-6xl">Choose how you want us to <span className="font-serif font-normal italic text-cobalt-700">grow with you.</span></h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-5">
        <p className="text-base leading-relaxed text-ink/70 sm:text-lg">Select the exact outbound sales capability your company needs, with performance-aligned delivery and predictable fixed operational costs.</p>
      </Reveal>
    </div>
    <div className="grid gap-5 lg:grid-cols-3">
      {PLANS.map((p, i) => <Plan key={p.id} p={p} i={i} />)}
    </div>
    <p className="mt-8 text-[14px] text-ink/60" data-testid="pricing-footnote">* You pay the monthly minimum or applicable performance fee, whichever is greater.</p>
  </section>
);
